import { render, staticRenderFns } from "./LittleGateOtherDamages.vue?vue&type=template&id=ae3c7e6e&scoped=true"
import script from "./LittleGateOtherDamages.vue?vue&type=script&lang=ts"
export * from "./LittleGateOtherDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3c7e6e",
  null
  
)

export default component.exports